import {getAssetPath} from "../../../../utils/get-asset-path.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

export const USER_IMAGE = getAssetPath("img/user.png");

export const getAttachUrl = (attachId) => `${API_KEEPER}/ged/attach/${attachId}`;

export const getBackgroundImage = (matchModel) => {
    if (!matchModel) return USER_IMAGE;

    const attachId = matchModel.map(match => match?.matchAttachId).find(id => id);
    const imageId = matchModel.map(match => match?.registerAttachId).find(id => id);

    if (attachId) return getAttachUrl(attachId);
    if (imageId) return getAttachUrl(imageId);

    return USER_IMAGE;
};

export const formatPercentage = (percentage) => {
    if (percentage > 1) {
        return percentage.toFixed(2);
    } else if (percentage >= 0 && percentage <= 1) {
        return (percentage * 100).toFixed(2);
    } else {
        return 0;
    }
};

export const MATCH_REFERENCES = {
    CPF_MATCH: "Monitoramento de CPF",
    IMAGE_MATCH: "Monitoramento de imagem",
    EXTERNAL_MATCH: "Terceiros"
};

export const GENDER_REFERENCES = {
    MALE: "Masculino",
    FEMALE: "Feminino",
    OTHER: "Outros"
};

export const SIGN_ERRORS = {
    "individual.alarm.not.found": "Alarme não encontrado!",
    "individual.alarm.already.signed": "Esse alarme já foi assinado!"
};
